import { render, staticRenderFns } from "./ModalVotar.vue?vue&type=template&id=3a664742&scoped=true"
import script from "./ModalVotar.vue?vue&type=script&lang=js"
export * from "./ModalVotar.vue?vue&type=script&lang=js"
import style0 from "./ModalVotar.vue?vue&type=style&index=0&id=3a664742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a664742",
  null
  
)

export default component.exports